import { Survey } from "app/models/surveyScheme/survey";

export class WorkTask {
  public id: number;
  public status: WorkTask.Status;
  public disbandmentReason: string;
  public title: string;
  public planned: Date;
  public finished?: Date;
  public survey?: Survey;
}

export namespace WorkTask {

  export enum Status {

    New,
    Assigned,
    Done,
    Canceled
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/workTask.ts